/* eslint-disable */
import { THEME_CHANGE_PALETTE } from '../Theme.types';

/**
 * Change the colours of the current palette
 * @param {I18nServiceChangePaletteDto} dto The required params to change the paletee's colours
 * @returns {ActionCreator<FromPayload<MuiPaletteOptions, {}, THEME_CHANGE_PALETTE>>} The created `Action`
 */
const themeChangePalette = ({ palette }) => ({ fromPayload }) => {
  return fromPayload(palette, {}, THEME_CHANGE_PALETTE);
};

export default themeChangePalette;
